import React, { useEffect, useRef, useState } from "react";
import { AppBar } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MainNavbar from "./navbar/MainNavbar";
import TopBanner from "./navbar/TopBanner";
import MobileDrawer from "./navbar/MobileDrawer";

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showLogin, setShowLogin] = useState(false);

  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const hostname = window.location.hostname;

    const isMuzukuruDomain =
      hostname === "muzukuru.com" || hostname === "www.muzukuru.com";

    setShowLogin(!isMuzukuruDomain);
  }, []);

  useEffect(() => {
    if (searchOpen) {
      const timer = setTimeout(() => {
        inputRef.current?.focus();
      }, 200);

      return () => clearTimeout(timer);
    }
  }, [searchOpen]);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const handleNavigate = (href: string) => {
    navigate(href);
    setMobileMenuOpen(false);
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const trimmed = searchTerm.trim();

    if (!trimmed) return;

    console.log("Searching:", trimmed);
  };

  const topBannerBg = pathname === "/sponsorships" ? "#1b76d2" : "#6F4C3E";

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: "transparent",
          boxShadow: "none",
          zIndex: 1200,
        }}
      >
        <TopBanner backgroundColor={topBannerBg} />
        <MainNavbar />
      </AppBar>

      <MobileDrawer
        open={mobileMenuOpen}
        onClose={handleMobileMenuToggle}
        pathname={pathname}
        showLogin={showLogin}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleNavigate={handleNavigate}
        handleLoginClick={handleLoginClick}
        handleSearchSubmit={handleSearchSubmit}
      />
    </>
  );
};

export default NavBar;
